import { TLangPickItem } from '../state/locale/localeSlice';

export const APP_LANGUAGES: TLangPickItem[] = (
  [
    process.env.RU_LANG_SUPPORT && { value: 'ru', text: 'Русский' },
    { value: 'en', text: 'English' },
  ] as (TLangPickItem | false)[]
).filter(Boolean) as TLangPickItem[];
